import EmptyMessage from 'components/EmptyMessage'
import OrderContext from 'pages/Order/_context'
import RequestDriverRow from 'pages/Order/Modals/RequestDriverRow'
import PropTypes from 'prop-types'
import { useContext } from 'react'
import { Button, Form, Modal, Table } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import API from 'state/API'
import { estimateDelivery, loadDeliveryOptions, useDeliveryOptions } from 'state/Orders'
import { Alerts } from 'utils'

export default function RequestDriverModal({ show, doClose }) {
	const { t }           = useTranslation()
	const dispatch        = useDispatch()
	const deliveryOptions = useDeliveryOptions()
	const order           = useContext(OrderContext)

	//not a useEffect because, otherwise, would dispatch as soon as the OrderDetails load this component
	function onShow() {
		dispatch(estimateDelivery(order.id))
			.catch((e) => {
				Alerts.danger(e.message)
				doClose()
			})
	}

	function onExited() {
		dispatch(loadDeliveryOptions([])) //clear options, so if the modal is reopened, it will _only_ show refreshed data
	}

	return <Modal {...{ show, onShow, onExited }} onHide={doClose} id="modal-request-driver" className="d-print-none">
		<Form>
			<Modal.Header closeButton>
				<Modal.Title>{t('Request driver')}</Modal.Title>
			</Modal.Header>

			<Modal.Body>
				{!deliveryOptions || !deliveryOptions.length?
					<EmptyMessage sm icon="car-side" resource={API.RESOURCES.DELIVERY}
					              defaultMsg={t('No delivery options found...')} msg={t('CONTACT_ERROR')}
					/>
				:
					<Table size="sm" className="mb-0" borderless>
						<thead>
							<tr>
								<th>{t('Service')}</th>
								<th className="pickup-time" width="1">{t('Pickup time')}</th>
							</tr>
						</thead>
						<tbody>
							{deliveryOptions.map(opt => <RequestDriverRow key={opt.key} details={opt} onAssign={doClose}/>)}
						</tbody>
					</Table>
				}
			</Modal.Body>

			<Modal.Footer className="justify-content-start">
				<Button onClick={doClose} variant="outline" size="sm">{t('Cancel', { context: 'go back' })}</Button>
			</Modal.Footer>
		</Form>
	</Modal>
}

RequestDriverModal.propTypes = {
	show   : PropTypes.bool.isRequired,
	doClose: PropTypes.func.isRequired,
}
